import { gql } from "@apollo/client";

export const ResetPasswordMutation = gql`
  mutation ResetPassword($where: ResetPasswordInput!) {
    resetPassword(where: $where) {
      status
    }
  }
`;
